'use strict';

/**
 * Dependency with common.js
 * toggle class when element is in viewport, use to animate in css when element is visible
 *
 *********************/

var App = {
    scrollDirection:'down',
    scrollTop:0,
    setScrollTop: function(){

        this.setPreviousScroll(this.scrollTop);

        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    },

    previousScroll:0,
    setPreviousScroll: function(scroll){
        this.previousScroll = scroll;
    },

    isScrolling : function(){

        if(this.previousScroll === this.scrollTop) {
            this.scrollDirection = null;
            return false;
        }

        if(this.previousScroll > this.scrollTop) {
            this.scrollDirection = 'up';
        }
        else {
            this.scrollDirection = 'down';
        }

        return true;
    },

    limits : {
        xs: 480,
        xsm:720,
        sm: 960, //tablet-portrait
        md: 1280, //tablet-landscape
        lg: 1600
    },

    windowWidth: window.innerWidth,

    windowHeight : window.innerHeight,

    documentHeight : document.documentElement.offsetHeight

};
App.setScrollTop();


var Roll = (function(){

    var triggerElementSelector = '[data-roll]';
    var downClass = 'down';
    var upClass = 'up';

    var tolerance = 0;

    var elements = [];


    var fps = 60;
    var now;
    var then = Date.now();
    var interval = 1000/fps;
    var delta;

    var isFirst = true;

    var isScrolling = true;

    let requestAnimFrame = function(callback){
        return  window.requestAnimationFrame(callback)       ||
            window.webkitRequestAnimationFrame(callback) ||
            window.mozRequestAnimationFrame(callback)    ||
            window.oRequestAnimationFrame(callback)      ||
            window.msRequestAnimationFrame(callback)     ||
            function( callback ){
                window.setTimeout(callback, 1000 / 60);
            };
    };


    var loop = function(){

        requestAnimFrame(loop);

        now = Date.now();
        delta = now - then;

        if (delta > interval && isScrolling) {

            then = now - (delta % interval);

            if(isScrolling){
                App.setScrollTop();


                setGlobalSetting();
            }

            //scroll event
            if(App.previousScroll != App.scrollTop || isFirst){


                if(isFirst){
                    isFirst = false;
                }
            }

            isScrolling = false;
        }
    };

    var setGlobalSetting = function(){
        var body = $('body');
        var classStatus = 'scroll';
        var classOver = 'over-step';
        var classOverLatencyFirst = 'over-step-first';

        var classOverLatency = 'over-step-latency';

        var limit = 100;

        var latency = 100;

        var latency2 = 200;

        var min = 50;

        if(App.scrollTop && App.scrollTop > min){


            if(!body.hasClass(classStatus) ) {

                body.addClass(classStatus);
            }

            body.removeClass(upClass + ' ' + downClass);

            if(App.previousScroll > App.scrollTop) {
                App.scrollDirection = upClass;
            }
            else {
                App.scrollDirection = downClass;
            }

            body.addClass(App.scrollDirection );



            if(App.scrollTop > limit){
                if(!body.hasClass(classOver)) {
                    body.addClass(classOver);

                }
                $('#overlay').trigger('click');
            }
            else{
                body.removeClass(classOver);
            }

            if(App.scrollTop > (limit + latency)){
                if(!body.hasClass(classOverLatencyFirst)) {
                    body.addClass(classOverLatencyFirst);
                }
            }
            else{
                body.removeClass(classOverLatencyFirst);
            }
            if(App.scrollTop > (limit + latency2)){
                if(!body.hasClass(classOverLatency)) {
                    body.addClass(classOverLatency);
                }
            }
            else{
                body.removeClass(classOverLatency);
            }
        }
        else{
            body.removeClass(classStatus);
        }
    };




    var init = function(){

        window.addEventListener('scroll', function(){
            isScrolling = true;
        });


        loop();
    };

    return {
        init: init
    };

})();

export default Roll;



